import { checklistCounts, itemFulfillment, type ChecklistCounts } from '@dataroom/shared';
import type { DdFulfillmentStatus, DdPhaseSummary, DdRequest } from '@dataroom/shared';

/**
 * Overall checklist progress across every (visible) phase — the server's exact
 * per-phase buckets added up (ADR-0032), never a client-side estimate. Every
 * item counts, required or optional: an item is resolved only when it is
 * covered by a document or attested "doesn't apply". A seller's summary already
 * covers released phases only, so this is exactly what they should see.
 */
export type ChecklistProgress = ChecklistCounts;

export function overallProgress(phases: DdPhaseSummary[]): ChecklistProgress {
  return checklistCounts(phases);
}

/** Items resolved in one phase (covered + not applicable). */
export function phaseResolved(phase: Pick<DdPhaseSummary, 'covered' | 'notApplicable'>): number {
  return phase.covered + phase.notApplicable;
}

/** Whole-number share of a phase's items that are resolved; 0 when it is empty. */
export function phasePercent(
  phase: Pick<DdPhaseSummary, 'covered' | 'notApplicable' | 'total'>,
): number {
  return phase.total > 0 ? Math.round((phaseResolved(phase) / phase.total) * 100) : 0;
}

/** Where a requested item stands — the API's `fulfillmentStatus` (ADR-0030,
 * ADR-0032). An optional item with nothing is `missing`, like a required one. */
export type RequestState = DdFulfillmentStatus;

export function requestState(
  req: Pick<DdRequest, 'fulfillmentStatus' | 'provided' | 'notApplicable'>,
): RequestState {
  return itemFulfillment(req);
}
